import * as React from 'react';
import { Filter } from '../../../types';
import { FilterNames } from 'PyzShopUi/scripts/bike-search-page/constants';
import { translate } from 'PyzShopUi/scripts/utils/translate';

interface IFiltersProps {
    filters: Filter[];
    filtersMapping: any;
    storeConfig?: any;
    dispatch: React.Dispatch<any>;
}

const Filters: React.FunctionComponent<IFiltersProps> = props => {
    const displayFilters = () => (
        props.filters.map((filter: any) => {
            if (!props.filtersMapping.hasOwnProperty(filter.name)
                || !props.filtersMapping[filter.name].hasOwnProperty('filterComponent')
            ) {
                return null;
            }

            const FilterComponentName = props.filtersMapping[filter.name].filterComponent;

            return <FilterComponentName
                key={filter.name}
                name={filter.name}
                label={generateFilterLabel(filter.name)}
                tagLabelSuffix={generateTagLabelSuffix(filter.name)}
                options={filter.options}
                max={filter.max}
                min={filter.min}
                activeMax={filter.activeMax}
                activeMin={filter.activeMin}
                storeConfig={props.storeConfig}
                dispatch={props.dispatch}
            />;
        })
    );

    const generateFilterLabel = (filterName: string): string => {
        switch (filterName) {
            case FilterNames.CAPACITY:
                return translate('Engine size', 'search-page-filter');
            case FilterNames.YEAROFCONSTRUCTION:
                return translate('Year of manufacture', 'bike-db');
            default:
                return '';
        }
    };

    const generateTagLabelSuffix = (filterName: string): string|null => {
        let suffix: string|null = null;

        switch (filterName) {
            case FilterNames.CAPACITY:
                suffix = ` ${translate('cc', 'bike-db')}`;
        }

        return suffix;
    };

    return (
        <div className={`filter-list`}>
            {displayFilters()}
        </div>
    );
};

Filters.defaultProps = {
    storeConfig: {}
};

export default Filters;
